module.exports = __webpack_public_path__ + "media/images/bnr_side_2-93dc30753e9eed4e3a7150a8872f43c1.jpg";